import React, { useState } from 'react';
import { Navigation } from './components/Navigation';
import { Dashboard } from './components/Dashboard';
import { People } from './components/People';
import { Messages } from './components/Messages';
import { Settings } from './components/Settings';
export function App() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [selectedPersonId, setSelectedPersonId] = useState<number | null>(null);
  const [interestingPeople, setInterestingPeople] = useState<number[]>([1, 3, 5]);
  const [notRelevantPeople, setNotRelevantPeople] = useState<number[]>([4]);
  const [showToast, setShowToast] = useState<{
    message: string;
    type: 'success' | 'error';
  } | null>(null);
  const handlePersonSelect = (personId: number) => {
    setSelectedPersonId(personId);
  };
  const handleNavigateToTab = (tab: string) => {
    setActiveTab(tab);
  };
  const handleMarkInteresting = (personId: number) => {
    setInterestingPeople(prev => {
      if (!prev.includes(personId)) {
        return [...prev, personId];
      }
      return prev;
    });
    setNotRelevantPeople(prev => prev.filter(id => id !== personId));
    showToastMessage('Contact marked as interesting', 'success');
  };
  const handleMarkNotRelevant = (personId: number) => {
    setNotRelevantPeople(prev => {
      if (!prev.includes(personId)) {
        return [...prev, personId];
      }
      return prev;
    });
    setInterestingPeople(prev => prev.filter(id => id !== personId));
    showToastMessage('Contact marked as not relevant', 'success');
  };
  const showToastMessage = (message: string, type: 'success' | 'error') => {
    setShowToast({
      message,
      type
    });
    setTimeout(() => setShowToast(null), 3000);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-0">
      <Navigation activeTab={activeTab} setActiveTab={setActiveTab} data-id="element-1" />
      {activeTab === 'dashboard' && <Dashboard onPersonSelect={handlePersonSelect} onNavigateToTab={handleNavigateToTab} onMarkInteresting={handleMarkInteresting} onMarkNotRelevant={handleMarkNotRelevant} data-id="element-2" />}
      {activeTab === 'people' && <People onPersonSelect={handlePersonSelect} selectedPersonId={selectedPersonId} onMarkInteresting={handleMarkInteresting} onMarkNotRelevant={handleMarkNotRelevant} interestingPeople={interestingPeople} notRelevantPeople={notRelevantPeople} data-id="element-3" />}
      {activeTab === 'messages' && <Messages selectedPersonId={selectedPersonId} interestingPeople={interestingPeople} onShowToast={showToastMessage} data-id="element-4" />}
      {activeTab === 'settings' && <Settings data-id="element-5" />}
      {/* Global toast notification */}
      {showToast && <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50" data-id="element-6">
          <div className={`px-4 py-3 rounded-lg shadow-lg flex items-center ${showToast.type === 'success' ? 'bg-green-600 text-white' : 'bg-red-600 text-white'}`} data-id="element-7">
            <span data-id="element-8">{showToast.message}</span>
          </div>
        </div>}
    </div>;
}